import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Pre.module.scss.js';

var _excluded = ["children", "className"];

var Pre = function Pre(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("pre", _extends({
    className: cx(styles.pre, className)
  }, props), children);
};

Pre.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export { Pre as default };
//# sourceMappingURL=index.js.map
